export default __webpack_public_path__ + "static/media/bs1.2.e8e88880.png";